import { TFunction } from 'react-i18next'
import { ErrorsCode } from '../enums/errorsCodes'

export const getErrorCode = (errorCode: ErrorsCode, t: TFunction<'translation', undefined>) => {
  let returnStatus: {
    text: string
    value?: number
  } = {
    text: '',
  }

  /* const errorLocale = typeof errorCode == 'string' ? parseInt(errorCode) : errorCode */

  switch (errorCode) {
    case ErrorsCode.ERR_NOT_FOUND_USER:
      returnStatus = {
        text: t('loogbook.errorsCode.errorNotFoundUser'),
      }
      break
    case ErrorsCode.DUPLICATE_PLACES:
      returnStatus = {
        text: t('loogbook.errorsCode.duplicatePplaces'),
      }
      break
    case ErrorsCode.ERR_NOT_FOUND_STORE:
      returnStatus = {
        text: t('loogbook.errorsCode.errorNotFoundStore'),
      }
      break
    case ErrorsCode.ERR_NOT_FOUND_TYPE_ACTIVITY:
      returnStatus = {
        text: t('loogbook.errorsCode.errorNotFoundTypeActivity'),
      }
      break
    case ErrorsCode.ERR_OUT_DATE:
      returnStatus = {
        text: t('loogbook.errorsCode.errorOutDate'),
      }
      break
    case ErrorsCode.ERR_EMPTY_DATA:
      returnStatus = {
        text: t('loogbook.errorsCode.errorEmptyData'),
      }
      break
    case ErrorsCode.ERR_FIELDS_ALLOW:
      returnStatus = {
        text: t('loogbook.errorsCode.errorFieldsAllow'),
      }
      break
    case ErrorsCode.VALIDATION_ERROR:
      returnStatus = {
        text: t('loogbook.errorsCode.validationError'),
      }
      break
  }
  return {
    ...returnStatus,
    value: errorCode,
  }
}